import { render, staticRenderFns } from "./start.view.vue?vue&type=template&id=f87504f8&scoped=true"
import script from "./start.view.vue?vue&type=script&lang=js"
export * from "./start.view.vue?vue&type=script&lang=js"
import style0 from "./start.view.vue?vue&type=style&index=0&id=f87504f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87504f8",
  null
  
)

export default component.exports